/**
 * Base URL for fetches that also run on the server.
 *
 * A relative "/api/..." has no host during SSR, so those calls failed silently and the
 * pages rendered without their data — the public service pages were shipping to Google
 * and to logged-out visitors with no price and no stock, which is the one number that
 * makes someone sign up. In the browser the relative path is still the right answer:
 * it goes through nginx like everything else.
 */
const SSR_API_BASE =
  (typeof process !== "undefined" && process.env?.SSR_API_BASE) || "http://backend:8000";

/** Prefix a path so it resolves both in the browser and during server rendering. */
export function apiUrl(path: string): string {
  if (typeof window !== "undefined") return path;
  return `${SSR_API_BASE}${path}`;
}
